import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c68f26"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-tasks me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "form-label text-muted"
}, " รายละเอียด: ", -1))
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "latitude",
  class: "form-label text-muted"
}, " ละติจูด: ", -1))
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "location.longitude",
  class: "form-label text-muted"
}, " ลองจิจูด: ", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "activityMemoResultForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "activityDate",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.activityDate}])
          }, " วันที่: ", 2),
          (_ctx.submited && _ctx.errors.activityDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาเลือกวันที่ "))
            : _createCommentVNode("", true),
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.formData.activityDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.activityDate) = $event)),
            enableTimePicker: false,
            locale: "th-TH",
            format: "dd/MM/yyyy",
            weekStart: "0",
            position: "left",
            autoApply: "",
            placeholder: "กรุณาเลือกวันที่...",
            class: _normalizeClass(["form-control p-0", {'is-invalid': _ctx.submited && _ctx.errors.activityDate}]),
            onChange: _ctx.unsubmit
          }, null, 8, ["modelValue", "class", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            placeholder: "กรุณาป้อนรายละเอียด...",
            "aria-label": "description",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.description) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 544), [
            [
              _vModelText,
              _ctx.formData.description,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.latitude) = $event)),
                class: "form-control",
                placeholder: "กรุณาป้อนละติจูด...",
                "aria-label": "location.latitude",
                autocomplete: "off",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.formData.latitude,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.longitude) = $event)),
                class: "form-control",
                placeholder: "กรุณาป้อนลองจิจูด...",
                "aria-label": "location.longitude",
                autocomplete: "off",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.formData.longitude,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            disabled: _ctx.isLoading,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_14,
            _createTextVNode(" ลบ ")
          ], 8, _hoisted_13))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_16,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_15),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_18,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_17)
    ]),
    _: 1
  }, 8, ["onHide"]))
}